import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTranslation, Trans } from 'react-i18next';
import { Comment } from 'semantic-ui-react';

import { ActionTypes } from '../../../constants/Enums';
import ItemComment from './ItemComment';
import User from '../../User';

import styles from './Item.module.scss';

const Item = React.memo(({ type, data, createdAt, user }) => {
  const [t] = useTranslation();

  let contentNode;

  switch (type) {
    case ActionTypes.CREATE_SELLITEM:
      contentNode = (
        <Trans
          i18nKey="common.userAddedThisSellitemToCustomer"
          values={{
            user: user.name,
            customer: data.customer.name,
          }}
        >
          <span className={styles.author}>{user.name}</span>
          <span className={styles.text}>
            {' added this sellitem to '}
            {data.customer.name}
          </span>
        </Trans>
      );

      break;
    case ActionTypes.MOVE_SELLITEM:
      contentNode = (
        <Trans
          i18nKey="common.userMovedThisSellitemFromCustomerToCustomer"
          values={{
            user: user.name,
            fromCustomer: data.fromCustomer.name,
            toCustomer: data.toCustomer.name,
          }}
        >
          <span className={styles.author}>{user.name}</span>
          <span className={styles.text}>
            {' moved this sellitem from '}
            {data.fromCustomer.name}
            {' to '}
            {data.toCustomer.name}
          </span>
        </Trans>
      );

      break;
    default:
      contentNode = null;
  }

  return (
    <Comment>
      <span className={styles.user}>
        <User name={user.name} avatarUrl={user.avatarUrl} />
      </span>
      <div className={classNames(styles.content)}>
        <div>{contentNode}</div>
        <span className={styles.date}>
          {t('format:longDateTime', {
            postProcess: 'formatDate',
            value: createdAt,
          })}
        </span>
      </div>
    </Comment>
  );
});

Item.Comment = ItemComment;

Item.propTypes = {
  type: PropTypes.string.isRequired,
  data: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  createdAt: PropTypes.instanceOf(Date).isRequired,
  user: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
};

export default Item;
